module.exports = __webpack_public_path__ + "img/white_paper15.c3b55ae9.png";